/*------------------------------------*\
    NEWS ARTICLE
\*------------------------------------*/
class NewsArticle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const articleMain = self.elem.querySelector('[data-article-main]');
        const articleBody = self.elem.querySelector('[data-article-body]');
        const trigger = self.elem.querySelector('[data-expand-trigger]');
        const triggerText = trigger.querySelectorAll('[data-trigger-text]');

        trigger.addEventListener('click', evt => {
            articleBody.classList.toggle('is-expanded');
            articleMain.classList.toggle('is-expanded');

            triggerText.forEach(item => {
                item.classList.toggle('d-none');
            });
        });
    }
}

export default NewsArticle;
